<ui-dialog
    [open]="isDeactivateModalOpen"
    (closing)="closeDeactivateModalOpen()"
    header="{{ 'applicant-tracker.discardEmailAutomation' | translate }}"
>
    <p>{{ 'applicant-tracker.areYouSureYouWantToDiscardThisMessage' | translate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeactivateModalOpen()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="danger" (click)="allowNavigation()">{{ 'applicant-tracker.discard' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    [open]="isSaveModalOpen"
    (closing)="closeSave()"
    header="{{ 'applicant-tracker.saveEmailAutomation' | translate }}"
>
    <p>
        {{
            'applicant-tracker.theEmailSubjectWillBeAutomaticallySent'
                | translate: { subject: funnelMessageTemplate.subject ?? '', stageName: funnelTemplateStage.name }
        }}
    </p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeSave()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave(funnelMessageTemplateForm)">{{ 'save' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog [open]="isRemoveModalOpen" (closing)="closeRemoveModal()" header="{{ 'remove' | translate }}">
    <p>{{ 'applicant-tracker.areYouSureYouWantToRemoveThisFunnel' | translate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeRemoveModal()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="danger" (click)="onRemove()">{{ 'remove' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="applicant-tracker.editEmailAutomation"
        [back]="true"
        [backRoute]="previousPath"
        [subtitle]="'applicant-tracker.thisEmailWillBeSentTOAllActiveParticipants'"
    ></app-header>

    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-funnel-message-template-form
                    [funnelTemplateStage]="funnelTemplateStage"
                    [funnelMessageTemplate]="funnelMessageTemplate"
                    #funnelMessageTemplateForm
                ></app-funnel-message-template-form>
                <div class="flex justify-end">
                    <ui-button (click)="openRemoveModal()" type="ghost">{{ 'remove' | translate }}</ui-button>
                    <ui-button (click)="openSave()" type="primary">{{ 'save' | translate }}</ui-button>
                </div>
            </div>
        </div>
        <div class="sidebar">
            <app-customization-tokens></app-customization-tokens>
        </div>
    </div>
</div>
